import axios from '../request/http';
import {toFormData} from '../common/descriptions'

const setup = {
     // 电商管理账号新增/编辑
     addManageAccount(data){
        return axios.post("/hemei-admin/accountManage/village/addManageAccount", data );
    },
    //客服信息
    customerService(params) {
        return axios.get("/hemei-admin/EC/SystemManage/customerServiceList", { params });
    },
    // 删除客服信息
    delCustomer(params){
        return axios.delete("/hemei-admin/accountManage/delCustomer", { params });
    },
    // 新增/修改客服信息
    accountManageAdd(data){
        return axios.post("/hemei-admin/EC/SystemManage/addOrUpdate/CustomerService", data );
    },
    // 菜单栏
    menuBar(params){
        return axios.get("/hemei-admin/menu/getMenuList", { params });
    },
    // 新增修改菜单栏
    routeList(data){
        return axios.post("/hemei-admin/menu/addOrUpdMenu", data );
    },
    // 删除菜单栏
    routeDl(params){
        return axios.delete("/hemei-admin/menu/delMenu", { params });
    },
    // 更改菜单状态
    routeDel(data){
        return axios.post("/hemei-admin/menu/delMenu", toFormData(data) );
    },
    // 获取角色列表
    role(params){
        return axios.get("/hemei-admin/role/getRoleList", { params });
    },
    // 新增或修改角色
    modifyrole(data){
        return axios.post("/hemei-admin/role/saveOrUpdateRole", data );
    },
    // 角色状态更改
    changeRoleS(data){
        return axios.post("/hemei-admin/role/changeRoleStatus", toFormData(data) );
    },
    // 删除角色
    DelRole(params){
        return axios.delete("/hemei-admin/role/delRole", { params });
    },
    // 获取后台账号列表信息
    getAdminPage(params){
        return axios.get("/hemei-admin/admin/getAdminPage", { params } );
    },
    // 新增或修改 账号
    saveOrUpdateAdminInfo(data){
        return axios.post("/hemei-admin/admin/saveOrUpdateAdminInfo", data );
    },
    //账号修改密码
    updPassword(data){
        return axios.post("/hemei-admin/admin/updPassword", toFormData(data) );
    },
    // 删除账号
    delAdminInfo(params){
        return axios.delete("/hemei-admin/admin/delAdminInfo", { params });
    },
    // 更改账号状态
    changeAdminInfoStatus(data){
        return axios.post("/hemei-admin/admin/changeAdminInfoStatus", toFormData(data) );
    },
     // 获取后台账号列表信息
     getAdminPage(params){
        return axios.get("/hemei-admin/admin/getAdminPage", { params } );
    },
    // 电商管理台账户收益
    accountIncome(params){
        return axios.get("/hemei-admin/finance/EC/accountIncome", { params } );
    },
     // 管理员订单收入列表
     income(params){
        return axios.get("/hemei-admin/accountManage/getAccount/income", { params } );
    },
    // 管理员结算记录列表
    settlement(params){
        return axios.get("/hemei-admin/accountManage/getAccount/settlement", { params } );
    },
    // 提现账户编辑
    updateAccount(data){
        return axios.post("/hemei-admin/finance/EC/updateAccount", data );
    },
    // 电商提现
    withdrawal(params){
        return axios.get("/hemei-admin/finance/EC/withdrawal", { params } );
    },
    // 获取提现人信息
    GetAccountInfo(params){
        return axios.get("/hemei-admin/finance/EC/GetAccountInfo", { params } );
    },
        // 订单流水
        orderFlow(params){
            return axios.get("/hemei-admin/finance/EC/orderFlow", { params } );
        },
        // 导出流水账单
        orderFlowExport(params) {
            return axios.get("/hemei-admin/finance/EC/orderFlowExport", {params,responseType:'arraybuffer'});
        },
        
}

export default setup;


// WEBPACK FOOTER //
// ./src/api/setup.js